import { useNavigate } from 'react-router-dom'

import { Switcher } from '@shared-ui/components'
import { MenuItem } from '@shared-ui/components/Menu'

import { useTheme } from 'app/providers/theme'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { AccountCircle, InputIcon } from 'shared/assets/icons'
import { useAppDispatch, useLogout } from 'shared/lib'
import { LanguageSwitcher } from 'widgets/LanguageSwitcher/LanguageSwitcher'
import { closeUserProfileMobileMenu } from 'widgets/Sidebar'

export const UserProfileMenuMobile = () => {
    const { t } = useTranslation(['common', 'shared'])
    const [logout] = useLogout()
    const navigate = useNavigate()
    const { toggleTheme, theme } = useTheme()
    const dispatch = useAppDispatch()
    const menuRef = useRef<HTMLDivElement>(null)

    // Close the menu when clicking anywhere outside it. The avatar trigger is
    // excluded — it toggles the menu itself, so closing here would reopen it.
    useEffect(() => {
        const handlePointerDown = (event: PointerEvent) => {
            const target = event.target as Element | null
            if (
                menuRef.current?.contains(target as Node) ||
                target?.closest('[data-user-menu-trigger]')
            ) {
                return
            }
            dispatch(closeUserProfileMobileMenu())
        }
        document.addEventListener('pointerdown', handlePointerDown)
        return () =>
            document.removeEventListener('pointerdown', handlePointerDown)
    }, [dispatch])

    return (
        <div
            ref={menuRef}
            className="absolute right-2 top-10 z-10 w-[273px] rounded-lg bg-background-base shadow-modal lg:hidden"
        >
            <div className="flex flex-col p-2">
                <MenuItem
                    id="item-1"
                    handleActive={() => {}}
                    className="gap-4 border-b border-work-in-progress py-2 pl-5"
                    labelClassName="!text-greyBlue"
                    itemIcon={<AccountCircle />}
                    handleItemClick={() => {
                        navigate('/korisnicki-profil')
                    }}
                    label={t('shared:layout.user-profile')}
                />
                {/* <MenuItem
                    id="item-2"
                    handleActive={() => {}}
                    className="gap-2 border-b py-4"
                    labelClassName={'!text-greyBlue'}
                    itemIcon={<NotificationIcon />}
                    handleItemClick={() => {}}
                    label={t('shared:layout.notifications')}
                /> */}
                <MenuItem
                    id="item-3"
                    handleActive={() => {}}
                    className="gap-4 border-b border-b-work-in-progress py-2 pl-5"
                    labelClassName={'!text-greyBlue'}
                    itemIcon={
                        <Switcher
                            checked={theme === 'dark'}
                            variant="rounded"
                            size="base"
                            color="primary"
                            name=""
                            value={theme}
                            onChange={toggleTheme}
                        />
                    }
                    handleItemClick={toggleTheme}
                    label={t('shared:layout.theme-switcher')}
                />
                <div className="gap-4 border-b border-work-in-progress py-2">
                    <LanguageSwitcher isMobile />
                </div>
                <MenuItem
                    id="item-4"
                    handleActive={() => {}}
                    className="gap-4 border-b border-work-in-progress py-2 pl-5"
                    labelClassName={'text-background-error'}
                    itemIcon={<InputIcon />}
                    handleItemClick={() => {
                        logout()
                    }}
                    label={t('shared:layout.logout')}
                />
            </div>
        </div>
    )
}
